/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CategoryType } from './categoryType';

export interface Category { 
    entity_id: string;
    title: string;
    category_type: CategoryType;
    parent_id?: string;
    parent_title?: string;
    subcategories?: Array<Category>;
}